<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-card>
      <v-card-title class="pl-4" style="height: 64px">
        <span :class="data.name ? '':'grey--text'" class="title">{{data.name || '新增用户'}}</span>
        <span class="grey--text px-2" v-if="editing">正在编辑</span>
        <v-spacer></v-spacer>
        <div v-if="!newItem">
          <v-layout class="text-xs-right" wrap>
            <v-flex xs6>
              <span class="grey--text caption mr-2">登记时间</span>
              <span class="pr-4">{{timeStringify(data.creationTime)}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="grey--text caption mr-2">上次更新</span>
              <span class="pr-4">{{timeStringify(data.lastUpdateTime)}}</span>
            </v-flex>
          </v-layout>
        </div>
        <v-btn @click="goReadonly()" color="primary" flat v-if="editing">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <!--<h3>{{data === null}}/{{data}}/</h3>-->
        <v-container fluid grid-list-md>
          <v-layout class="mb-4" wrap>
            <v-flex sm4 xs12>
              <v-text-field
                :rules="$rules.required()"
                hint="必填"
                label="用户姓名"
                persistent-hint
                prepend-icon="$vuetify.icons.person"
                v-model="data.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs12>
              <v-text-field
                :disabled="editing"
                :rules="$rules.required()"
                hint="必填"
                label="用户账号"
                persistent-hint
                prepend-icon="$vuetify.icons.loginId"
                v-model="data.loginId"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs12>
              <v-text-field
                label="电子邮箱"
                prepend-icon="$vuetify.icons.email"
                v-model="data.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs12>
              <v-text-field
                label="电话号码"
                prepend-icon="$vuetify.icons.phone"
                v-model="data.phone"
              ></v-text-field>
            </v-flex>
            <!--<v-flex xs4>-->
            <!--<v-text-field-->
            <!--label="证件类型"-->
            <!--prepend-icon="$vuetify.icons.idCardType"-->
            <!--&gt;</v-text-field>-->
            <!--</v-flex>-->
            <!--<v-flex xs4>-->
            <!--<v-text-field-->
            <!--label="证件号码"-->
            <!--prepend-icon="$vuetify.icons.idCard"-->
            <!--&gt;</v-text-field>-->
            <!--</v-flex>-->
            <v-flex sm4 xs12>
              <v-text-field
                :value="data.typeName"
                disabled
                label="登记类型"
                placeholder="N/A"
                prepend-icon="$vuetify.icons.group"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 xs12>
              <v-text-field
                :value="data.orgGroupName"
                disabled
                label="所在单位"
                placeholder="请绑定单位用户组"
                prepend-icon="$vuetify.icons.org"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select chips :items="data.groupList" item-text='name'
                        item-value='id' label="驾驶员所属单位列表" prepend-icon="$vuetify.icons.group" v-model="data.driverOrgs" clearable
              multiple></v-select>
            </v-flex>
            <v-layout column class="pl-4">
              <v-flex xs12>
                <v-subheader>驾驶证明</v-subheader>
                <v-flex xs12>
                  <l-select-file
                    @input="addFile(arguments[0], data.driverLicense)"
                    file-type="image/*"
                    title="添加图片"
                  >
                    <v-btn color="primary" flat slot="activator" :disabled="data.driverLicense.length===1" >
                      上传驾驶证明<span class="error&#45;&#45;text caption" >（至多只上传一张图片）</span>
                    </v-btn>
                  </l-select-file>
                </v-flex>
                <l-image v-if="data.driverLicense.length === 0"></l-image>
                <l-image-dialog
                  :src="img.src"
                  v-for="(img,i) in data.driverLicense" :key="i">
                  <l-image
                    slot="activator"
                    :src="img.src"
                    :error="img.error"
                    :errorMessage="img.errorMessage"
                  >
                    <template slot="action">
                      <v-tooltip bottom>
                        <span>删除图像</span>
                        <v-btn slot="activator" @click="deleteImage(data.driverLicense, i)" icon>
                          <v-icon>$vuetify.icons.delete</v-icon>
                        </v-btn>
                      </v-tooltip>
                    </template>
                  </l-image>
                </l-image-dialog>
              </v-flex>
            </v-layout>
            <v-flex xs12 v-if="from==='superAdmin'">
              <v-btn flat color="primary" @click="showExtend=!showExtend" v-if="!showExtend">显示附加信息</v-btn>
              <v-btn flat color="primary" @click="showExtend=!showExtend" v-if="showExtend">隐藏附加信息</v-btn>
            </v-flex>
            <v-layout column xs12 v-if="showExtend&&data.extend.length!==0">
              <v-layout v-for="(p,index) in data.extend" :key="index">
                <v-flex xs3>
                  <v-text-field label="Key" v-model="p.key" prepend-icon="$vuetify.icons.code" readonly></v-text-field>
                </v-flex>
                <v-flex xs9>
                  <v-textarea label="参数值" v-model="p.value" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow></v-textarea>
                </v-flex>
              </v-layout>
            </v-layout>
            <v-flex xs12>
              <!--<v-btn color="grey" flat v-if="editing">取消</v-btn>-->
              <v-btn :disabled="!hasChanged" :loading="infoLoading" @click="setUser()" color="primary" flat>提交修改</v-btn>
            </v-flex>
          </v-layout>
          <v-subheader>绑定分组</v-subheader>
          <v-layout class="mb-4" wrap>
            <v-flex xs12>
              <l-data-table
                :headers="groupHeaders"
                :items="data.groupList"
                flat
                hide-actions
                hide-headers
                hide-title
                no-data-text="没有绑定用户组"
              >
                <template slot="row-action" slot-scope="{item}">
                  <td @click.stop class="px-0 mx-0 text-xs-right">
                    <v-btn @click="deleteGroup(item)" icon>
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </l-data-table>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="openGroupDialog" class="mx-0" color="primary" flat>添加分组</v-btn>
            </v-flex>
          </v-layout>
          <v-subheader>绑定角色</v-subheader>
          <v-layout wrap>
            <v-flex xs12>
              <l-data-table
                :headers="roleHeaders"
                :items="data.roleList"
                flat
                hide-actions
                hide-headers
                hide-title
                no-data-text="没有绑定角色"
              >
                <template slot="row-action" slot-scope="{item}">
                  <td @click.stop class="px-0 mx-0 text-xs-right">
                    <v-btn @click="deleteRole(item)" icon>
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </l-data-table>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="openRoleDialog" class="mx-0" color="primary" flat>添加角色</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <!--<v-flex class="text-xs-right my-4">-->
    <!--<v-btn color="grey" flat v-if="editing">取消</v-btn>-->
    <!--<v-btn color="primary">提交</v-btn>-->
    <!--</v-flex>-->
    <l-dialog
      :auto-close="newItem"
      :loading="roleDialog.loading"
      @cancel="roleDialog.activate = false"
      @confirm="addRoles(roleDialog.roles)"
      hide-divider
      max-width="500px"
      title="添加角色"
      v-model="roleDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :get-data="getRoles"
          item-text="name"
          label="添加角色"
          multiple
          prepend-icon="$vuetify.icons.role"
          v-model="roleDialog.roles"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
    <l-dialog
      :auto-close="newItem"
      :loading="groupDialog.loading"
      @cancel="groupDialog.activate = false"
      @confirm="addGroups(groupDialog.groups)"
      hide-divider
      max-width="500px"
      title="添加分组"
      v-model="groupDialog.activate"
    >
      <v-container>
        <l-autocomplete
          :get-data="getGroups"
          item-text="name"
          label="添加分组"
          multiple
          prepend-icon="$vuetify.icons.group"
          v-model="groupDialog.groups"
        ></l-autocomplete>
      </v-container>
    </l-dialog>
  </l-layout>
</template>

<script>
import {time} from '../../../../ladmin/utils/time'
import {GROUP_ACTION_HEADERS} from '../../../../consts/userAdmin'
import {PassRule} from '../../../../object'

export default {
  name: 'userDetailsEdit',
  props: {
    status: {type: String, default: 'readonly'},
    data: {type: Object, default: () => ({})},
  },
  data: () => ({
    showExtend: false,
    from: 'user',
    hasChanged: false,
    infoLoading: false,
    roleDialog: {
      activate: false,
      loading: false,
      roles: [],
    },
    passDialog: {},
    groupDialog: {
      activate: false,
      loading: false,
      groups: [],
    },
    groupHeaders: GROUP_ACTION_HEADERS,
    roleHeaders: [
      {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', sortable: false, width: '80px'},
    ],
  }),
  computed: {
    newItem () {
      return this.status === 'new'
    },
    editing () {
      return this.status === 'edit'
    },
  },
  watch: {
    data: {
      handler () {
        this.hasChanged = true
      },
      deep: true,
    },
  },
  methods: {
    openRoleDialog () {
      this.roleDialog = {
        activate: true,
        loading: false,
        roles: [],
      }
    },
    openGroupDialog () {
      this.groupDialog = {
        activate: true,
        loading: false,
        groups: [],
      }
    },
    async getGroups (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getGroups', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async getRoles (val) {
      try {
        let {items} = await this.$store.dispatch('userAdmin/getRoles', {
          pagination: {page: 1, rowsPerPage: 10},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', e.message)
        return []
      }
    },
    async deleteGroup (group) {
      if (this.newItem) {
        this.data.deleteGroup(group)
      }
      else {
        let {res, close} = await this.$L.confirm({title: '确认删除', text: `确认删除分组${group.name}？`})
        try {
          if (res) {
            await this.$store.dispatch('userAdmin/userUnbindGroups', {groups: [group], user: this.data})
            this.$L.alert('success', '删除成功')
            this.$emit('refresh')
          }
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
        finally {
          close()
        }
      }
    },
    async deleteRole (role) {
      if (this.newItem) {
        this.data.deleteRole(role)
      }
      else {
        let {res, close} = await this.$L.confirm({title: '确认删除', text: `确认删除角色${role.name}？`})
        try {
          if (res) {
            await this.$store.dispatch('userAdmin/userUnbindRole', {role: role, user: this.data})
            this.$L.alert('success', '删除成功')
            this.$emit('refresh')
          }
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
        finally {
          close()
        }
      }
    },
    async setUser () {
      this.infoLoading = true
      let extendSubmit = {}
      for (let i = 0; i < this.data.extend.length; i++) {
        let item = this.data.extend[i]
        extendSubmit[item.key] = item.value
      }
      extendSubmit.driverOrgs = this.data.driverOrgs
      if (this.data.driverOrgs.length !== 0 && this.data.driverLicense.length === 0) {
        this.$L.alert('error', {message: '请上传驾驶证明再提交'})
        this.infoLoading = false
        return
      }
      let url = ""
      if(this.data.driverLicense.length===0){
        url = ""
      }else if(this.data.driverLicense[0].url===undefined){
        url = this.data.driverLicense[0].src
      }else{
        url = this.data.driverLicense[0].url
      }
      let file = {
        pic: [
          {name: '驾驶证', url1: url},
          {name: '行驶证', url2: ''},
          {name: '其他证明', url3: ''}
        ],
        msg: ''
      }
      extendSubmit.file = JSON.stringify(file)
      this.data.extendSubmit = JSON.stringify(extendSubmit)
      try {
        await this.$store.dispatch('userAdmin/setUser', this.data)
        this.$emit('refresh')
        this.$L.alert('success', {message: '修改成功'})
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
      }
      finally {
        this.infoLoading = false
      }
    },
    async addRoles (items) {
      console.log('addRole', items)
      if (items instanceof Array && items.length) {
        if (this.newItem) {
          this.data.addRole(...items)
        }
        if (this.editing) {
          try {
            this.roleDialog.loading = true
            await this.$store.dispatch('userAdmin/userBindRoles', {user: this.data, roles: items})
            this.$emit('refresh')
          }
          catch (e) {
            this.$L.alert('error', {message: 'e'})
          }
          finally {
            this.roleDialog.activate = false
            this.roleDialog.loading = false
          }
        }
      }
    },
    async addGroups (items) {
      console.log('addGroups', items)
      if (items instanceof Array && items.length) {
        if (this.newItem) {
          this.data.addGroup(...items)
        }
        if (this.editing) {
          try {
            this.groupDialog.loading = true
            await this.$store.dispatch('userAdmin/userBindGroups', {user: this.data, groups: items})
            this.$emit('refresh')
          }
          catch (e) {
            this.$L.alert('error', {message: 'e'})
          }
          finally {
            this.groupDialog.activate = false
            this.groupDialog.loading = false
          }
        }
      }
    },
    timeStringify (t) {
      return time.stringify(t)
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'UserDetails',
          params: {loginId: this.data.loginId},
          query: {id: this.data.id, from: this.from},
        })
      })
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        target.push(temp)
        // 上传图片
        let img = await this.uploadFile(file)
        this.$set(target, target.length - 1, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        // console.log(img)
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    },
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      this.$set(img, 'src', 'https://smaco2.uestc.edu.cn/passApi' + path)
      img.loading = false
    }
  },
  created () {
    if (this.$route.query.showExtend !== undefined) {
      this.showExtend = this.$route.query.showExtend
    }
    if (this.$route.query.from !== undefined) {
      this.from = this.$route.query.from
    }
    console.log(this.data)
  },
}
</script>

<style scoped>

</style>
